import { AgentRunThread } from '@system/search/cipo-ai/cipo-ai.component';

export type AiReasoningStepKind = 'thinking' | 'reasoning' | 'tool_call' | 'error';

export type AiReasoningStep = {
  kind: AiReasoningStepKind;
  label: string;
  chatId?: string;
};

export type AiState = {
  threads: AgentRunThread[];
  thread: AgentRunThread;
  loading: boolean;
  viewMode: 'thread' | 'threads';
  sidebarWidth: number;
  reasoningSteps: AiReasoningStep[];
  lastReasoningSteps: AiReasoningStep[];
  softTimeoutPromptVisible: boolean;
  softTimeoutSeconds: number;
  extensionTimeoutSeconds: number;
  elapsedTimeoutSeconds: number;
};

export const initialState: AiState = {
  threads: [],
  thread: null,
  loading: false,
  viewMode: 'thread',
  sidebarWidth: 400,
  reasoningSteps: [],
  lastReasoningSteps: [],
  softTimeoutPromptVisible: false,
  softTimeoutSeconds: 30,
  extensionTimeoutSeconds: 30,
  elapsedTimeoutSeconds: 0,
};

export enum AiStoreActions {
  LoadThreads = '[Ai Store] LoadThreads',
  LoadThreadsSuccess = '[Ai Store] LoadThreadsSuccess',
  SelectThread = '[Ai Store] SelectThread',
  SelectThreadSuccess = '[Ai Store] SelectThreadSuccess',
  AskQuestion = '[Ai Store] AskQuestion',
  AskQuestionSuccess = '[Ai Store] AskQuestionSuccess',
  DeleteThread = '[Ai Store] DeleteThread',
  DeleteThreadSuccess = '[Ai Store] DeleteThreadSuccess',
  SetLoading = '[Ai Store] SetLoading',
  SetViewMode = '[Ai Store] SetViewMode',
  NewThread = '[Ai Store] NewThread',
  UpdateSidebarWidth = '[Ai Store] UpdateSidebarWidth',
  AddReasoningStep = '[Ai Store] AddReasoningStep',
  ClearReasoningSteps = '[Ai Store] ClearReasoningSteps',
  SoftTimeoutReached = '[Ai Store] SoftTimeoutReached',
  KeepWaiting = '[Ai Store] KeepWaiting',
  StopRequest = '[Ai Store] StopRequest',
}
